import _                           from 'underscore';
import React, { FC }               from 'react';
import { useQuery }                from '@apollo/react-hooks';
import { QueriedSelectFieldProps } from '../formik';

import { CorvalCategory, CorvalSubCategory } from '../../../../types';
import { queriesHaveData, queriesLoading }   from '../../../../store/_apolloUtil';
import { DecisionEngineQueries }             from '../../../../queries';
import { formatOption }                      from '../../../../util';
import { SelectField }                       from '../../../components/forms';

interface SubCategoryDropdownProps extends QueriedSelectFieldProps {
	loading?: boolean,
	formatOptions?: object,
}

const defaultProps: SubCategoryDropdownProps = {
	loading:       false,
	formatOptions: {},
};

const SubCategoryDropdown: FC<SubCategoryDropdownProps> = ( _props ) => {
	
	let { formatOptions, ...props } = _props;
	
	let getCategoriesReq = useQuery(
		DecisionEngineQueries.queries.GET_CATEGORIES( `id name ordinal subCategories{ id name ordinal }` ), {
			variables:   { order: { ordinal: 'ASC' } },
			fetchPolicy: 'cache-and-network'
		} );
	
	let isLoading = ( props.loading || queriesLoading( getCategoriesReq ) );
	
	let options = queriesHaveData( getCategoriesReq ) ?
	              getCategoriesReq.data.categories.map( ( category: CorvalCategory ) => {
		
		              let options = _.sortBy( category.subCategories, 'ordinal' )
		                             .map( ( subcategory: CorvalSubCategory ) => (
			                             formatOption(
				                             subcategory.id,
				                             subcategory.name,
				                             { group: category.name, ...formatOptions }
			                             ) )
		                             );
		
		              return _.isEmpty( options ) ? null : options;
		
	              } ) : [];
	
	options = _.chain( options ).flatten().compact().value();
	
	return (
		<SelectField
			{ ...props }
			search
			useGroupNames={ true }
			loading={ isLoading }
			options={ options }
		/>
	);
};

SubCategoryDropdown.defaultProps = defaultProps;

export { SubCategoryDropdown };
